(async (win) => {
  const constant = window.hanlin.constant
  let edu
  let year

  const updateEudFromUrl = () => {
    // 檢查
    const url = window.location.href;
    if (url.includes('/el/')) {
      edu = "國小";
    } else if (url.includes('/jr/')) {
      edu = "國中";
    }else if (url.includes('/sh/')) {
      edu = "高中";
    }else {
      $("a[href='../index.html']").click();
    }
  }

  const initYear = () => {
    const url = new URL(window.location.href)
    year = url.searchParams.get("year")
    if (!year) {
      // 預設顯示的年度
      if (edu === "國小") {
        year = 114
      } else if (edu === "國中") {
        year = 114
      } else if (edu === "高中") {
        year = 114
      }
    }
  }

  const initSubject = () => {
    const subjects = constant.EDU_SUBJECT_MAP[edu]
    const subjectItem = document.querySelector('.subject_item')
    subjectItem.innerHTML = ''
    let subjectHtml = ''
    subjects.forEach((subject) => {
      if (subject !== '技高國文' && subject !== '技高英文'){
        subjectHtml = subjectHtml + `
        <li><a href="./refer_infolist.html?edu=${edu}&subject=${subject}&year=${year}">${subject}</a></li>
      `
      }
    })
    subjectItem.innerHTML = subjectHtml

    let otherSubjectHtml = "";
    if (edu === "高中"){
      otherSubjectHtml = `<ul>
                            <li><a href="./refer_infolist.html?edu=${edu}&subject=技高國文&year=${year}">技高國文</a></li>
                            <li><a href="./refer_infolist.html?edu=${edu}&subject=技高英文&year=${year}">技高英文</a></li>
                        </ul>`;
      subjectItem.innerHTML += otherSubjectHtml
    }
  }

  const checkLogin = async () => {
    const url = window.location.href;
    // 是否有攜帶 accessToken
    let accessToken = new URL(url).searchParams.get("token")

    if (accessToken !== null){
      // 確定 accessToken 是否有效
      let profile = await win.getUserInfoByEndpoint(accessToken)

      if ( profile ) {
        const user = {
          id_token: null,
          access_token: accessToken
        }
        await win.updateUserInfo(user, profile.data)
        removeQueryParam("token")
      } else {
        const redirectUrl = window.location.href.split("?")[0]
        await win.login(redirectUrl)
      }
    }
  }

  const addTabSwitchEvent = () => {
    $(".item-menu a").click(function (event) {

      $(this).parent().addClass("current");
      $(this).parent().siblings().removeClass("current");
      var tab = $(this).attr("href");
      $(".item-content").not(tab).css("display", "none");
      $(tab).show();
    });
  }

  const removeQueryParam = (paramToRemove) => {
    // 建立當前 URL 的 URL 物件
    const url = new URL(window.location);

    // 移除指定的查詢參數
    url.searchParams.delete(paramToRemove);

    // 使用 history API 更新瀏覽器的 URL，但不重新載入頁面
    window.history.pushState({}, '', url);
  }
  const init = async () => {
    updateEudFromUrl()
    initYear()
    addTabSwitchEvent()
    await checkLogin()
    await win.addTestBankLink(edu)
    initSubject()
  }

  await init()
})(window)
